import { Lambda, autorun } from "mobx";
import { Retriever, IState } from "../../../../common";
import { SportModel, sportDictionary } from "../..";

export class AllSportsRetriever extends Retriever<SportModel> {
    private readonly allSportsItemId: string = "all";
    private readonly dict: sportDictionary;
    private subscription: Lambda;

    constructor (dict: sportDictionary) {
        super();
        this.dict = dict;
        this.subscription = () => {};
    }

    async activate(state: IState<SportModel>) {
        this.subscription = autorun(() => {
            this.calcAllSports(state);
        });
    }

    private calcAllSports(state: IState<SportModel>) {
        const count = this.getAllSportsCount(state);
        if (state.getItemById(this.allSportsItemId)) {
            state.update(this.allSportsItemId, { numberOfEvents: count });
        }
        else {
            state.add(this.getAllSportsItem(count));
        }
    }

    private getAllSportsItem(count: number): SportModel {
        return new SportModel({
            id: "all",
            name: this.dict.allSports,
            numberOfEvents: count,
            order: -2
        }, "allSports");
    }

    private getAllSportsCount(state: IState<SportModel>) {
        return state.Items.filter(x => x.type === "sports").reduce((y, x) => y + x.numberOfEvents, 0);
    }

    deactivate() {
        this.subscription();
    }
}